// extracted by mini-css-extract-plugin
export default {"productbox":"featured_productbox__cbfYK","product_container":"featured_product_container__YfvA7"};